<template>
  <div>
    <page-header
      slot="header"
      ref="header"
      @submit="handleSubmit"
      @chooseGroupAdd="chooseGroupAdd"
    ></page-header>
    <page-main
      class="mt-2"
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="handleSubmit"
    />
    <p></p>
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main'),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      groupCodeList: [],
    }
  },
  methods: {
    load(groupCodeList) {
      this.groupCodeList = groupCodeList
      this.handleSubmit()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      let params = { groupCodeList: this.groupCodeList }
      this.$api
        .scmAppraisalChoiceGroupListApi({
          ...form,
          ...params,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseGroupAdd() {
      let data = this.$refs.main.selectionChange()
      this.$emit('chooseGroupAdd', data)
    },
  },
}
</script>
